import { render, staticRenderFns } from "./ProgramReportingDashboard.vue?vue&type=template&id=bb27f9d4&scoped=true"
import script from "./ProgramReportingDashboard.vue?vue&type=script&lang=js"
export * from "./ProgramReportingDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProgramReportingDashboard.vue?vue&type=style&index=0&id=bb27f9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27f9d4",
  null
  
)

export default component.exports